import { FlexCol, FlexRow } from '@/components/common/Flex';
import { Box, FlexProps, Skeleton } from '@chakra-ui/react';
import { usePageContext } from '@common/react/pageMode';
import {
    getPartnerName,
    getPreferredOrFirstName,
    isSingleplayer,
    useCurrentUser,
} from '@common/react/user';
import { FC } from 'react';
import FadeInBox from '../FadeInBox';
import { EyebrowHeader, Title } from '../Typography';

export interface PageTitleSectionProps extends Omit<FlexProps, 'title'> {
    title?: string | JSX.Element;
    rightContent?: JSX.Element;
}

const PageTitleSection: FC<PageTitleSectionProps> = ({
    title,
    rightContent,
    ...props
}) => {
    const currentUser = useCurrentUser();
    const { userInfo, partnerInfo } = currentUser;
    const { pageMode } = usePageContext();
    let eyebrow = getPreferredOrFirstName(userInfo);
    if (partnerInfo && pageMode === 'PUBLIC' && !isSingleplayer(currentUser)) {
        eyebrow =
            getPreferredOrFirstName(userInfo) +
            ' & ' +
            getPartnerName(partnerInfo, 'your partner');
    }

    return (
        <FadeInBox
            key={'page-title-' + pageMode}
            w="full"
            flexDirection={{ base: 'column', md: 'row' }}
            justify="space-between"
            mb={4}
            alignItems={{ base: 'flex-start', md: 'flex-end' }}
            {...props}
        >
            <FlexCol grow={1}>
                {/* Fixed height to ensure spacing stays consistent between
                pages, regardless of whether eyebrow text is present and/or
                title is string or element */}
                <Box minH={4}>
                    <EyebrowHeader mb={0}>{eyebrow}</EyebrowHeader>
                </Box>
                <FlexRow align="flex-end" minH={8}>
                    {!title ? (
                        <Skeleton h={6} w={80} />
                    ) : typeof title === 'string' ? (
                        <Title>{title}</Title>
                    ) : (
                        title
                    )}
                </FlexRow>
            </FlexCol>
            {rightContent && <Box mt={{ base: 4, md: 0 }}>{rightContent}</Box>}
        </FadeInBox>
    );
};

export default PageTitleSection;
